import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Message_1: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			rotate: 0,
		},
		config: {
			duration: 800,
		},
		onRest: (_, spring) => spring.set({ rotate: 0 }),
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ rotate: 360 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path d="M209.24 207.49L60.31 128.57v-3a27.94 27.94 0 0127.93-27.95H337A27.91 27.91 0 01364.87 125z" />
				<path d="M364.89 147.54v137A27.94 27.94 0 01337 312.47H88.24a27.94 27.94 0 01-27.93-27.93V151.1l142.22 75.34a13.09 13.09 0 006.13 1.52h.6a5.52 5.52 0 00.58 0 13.06 13.06 0 006.1-1.52z" />
			</svg>
		</animated.span>
	)
}

export { Message_1 }
